/*
  fav-count-up.js — Favoritten.dk

  Taeller tal op naar de kommer i syne. Elementet indeholder ALLEREDE det
  faerdige tal fra Liquid; vi laaner det bare et oejeblik. Gaar JavaScript
  galt, eller er scriptet blokeret, staar det rigtige tal der stadig.

  IntersectionObserver frem for at starte ved load: hero'en er oeverst nu,
  men sektioner flyttes rundt i temaeditoren, og en optaelling der er
  overstaaet foer man scroller ned til den er spildt.
*/
(function () {
  'use strict';

  var reduceret = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Dansk tusindtalsseparator er punktum. toLocaleString('da-DK') giver
     det rigtige, men falder tilbage til et simpelt regex hvis localen
     ikke findes i browseren. */
  function formater(n) {
    try {
      return n.toLocaleString('da-DK');
    } catch (e) {
      return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    }
  }

  /* Laaser bredden FOER teksten roeres.

     Elementet indeholder stadig det faerdige tal paa dette tidspunkt, saa
     dets bredde er praecis den plads tallet ender med at fylde. Uden
     laasen skubber resten af overskriften sig, mens tallet vokser fra ét
     til seks tegn. Det kostede 0,034 i CLS.

     Maalt, ikke regnet ud. Foer reserverede Liquid pladsen som antal tegn
     gange ch, men ch er bredden af et nul, og punktummet i "12.152" er
     langt smallere. Overskuddet stod som et synligt hul mellem tallet og
     det naeste ord. */
  function laasBredde(el) {
    var b = el.getBoundingClientRect().width;
    if (b > 0) el.style.minWidth = b + 'px';
  }

  function taelOp(el) {
    var maal = parseInt(el.getAttribute('data-count-to'), 10);
    if (!maal || maal < 0) return;

    laasBredde(el);

    var suffiks = (el.textContent.match(/[^\d.,\s]+$/) || [''])[0];
    var varighed = 1100;
    var start = null;

    function trin(nu) {
      if (start === null) start = nu;
      var t = Math.min((nu - start) / varighed, 1);
      /* easeOutCubic: hurtigt i starten, blidt til sidst */
      var e = 1 - Math.pow(1 - t, 3);
      el.textContent = formater(Math.round(maal * e)) + suffiks;
      if (t < 1) requestAnimationFrame(trin);
    }

    el.textContent = formater(0) + suffiks;
    requestAnimationFrame(trin);
  }

  function start() {
    var felter = document.querySelectorAll('[data-count-to]');
    if (!felter.length) return;

    /* Reduceret bevaegelse eller ingen observer: lad tallet staa som det er */
    if (reduceret || !('IntersectionObserver' in window)) return;

    var obs = new IntersectionObserver(function (poster) {
      poster.forEach(function (p) {
        if (!p.isIntersecting) return;
        obs.unobserve(p.target);
        taelOp(p.target);
      });
    }, { threshold: 0.4 });

    felter.forEach(function (el) { obs.observe(el); });
  }

  /* Bredden maales, og en maaling taget mens reserveskriften stadig er i
     brug rammer forkert: tallet ville faa reserveret plads i den forkerte
     skrifttype. Vent paa skrifttyperne, hvis browseren kan sige hvornaar
     de er klar. Begge argumenter til then er den samme funktion, saa vi
     starter ogsaa selv om en skrifttype fejler. */
  function naarSkrifterErKlare(fn) {
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(fn, fn);
    } else {
      fn();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      naarSkrifterErKlare(start);
    });
  } else {
    naarSkrifterErKlare(start);
  }
})();
